<template>
  <div class="ma-4">
    <ClientNav />
    <v-row dense>
      <v-col cols="12" lg="3" xl="2">
        <ClientSide />
      </v-col>
      <v-col cols="12" lg="9" xl="10">
        <v-card>
          <v-tabs v-model="tab">
            <v-tabs-slider color="yellow"></v-tabs-slider>
            <v-tab
              v-for="(item, i) in items"
              :key="item"
              @click="onChangeTab(i)"
            >
              {{ item }}
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item v-for="(item, i) in items" :key="item">
              <template>
                <v-card class="pa-2" outlined tile height="100%">
                  <v-data-table
                    :headers="headers"
                    :items="
                      i === 0
                        ? allClientMedHandOffData
                        : allClientMedHandOffData
                    "
                    sort-by="Date"
                    sort-desc
                    :loading="$store.state.medhandoff.isLoading"
                    loading-text="Loading Medication Hand Offs"
                    :search="search"
                    height="550"
                  >
                    <template v-slot:top>
                      <v-toolbar flat color="white">
                        <v-toolbar-title
                          ><span class="text-caption text-sm-body-1"
                            >{{
                              i === 0
                                ? "Outgoing Medhandoff"
                                : "Incoming Medhandoff"
                            }}
                          </span></v-toolbar-title
                        >
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                        <v-text-field
                          v-model="search"
                          clearable
                          flat
                          solo-inverted
                          hide-details
                          prepend-inner-icon="search"
                          label="search"
                          class="desktop"
                        ></v-text-field>
                        <v-spacer></v-spacer>
                        <action-control-menu
                          ref="actions"
                          :actions="['Print', 'Download']"
                          :navigateTo="navigateTo"
                          :payload="payload"
                          :isAuditorRole="isAuditorRole"
                          btnTitle="New"
                        />
                      </v-toolbar>
                      <v-text-field
                        v-model="search"
                        clearable
                        flat
                        solo-inverted
                        hide-details
                        prepend-inner-icon="search"
                        label="search"
                        class="mobile ml-5 mr-5 mb-3 mt-3"
                      ></v-text-field>
                    </template>

                    <template v-slot:item.actions="{ item }">
                      <v-icon
                        small
                        class="mr-2 hidden-sm-and-down"
                        @click="viewItem(item)"
                      >
                        mdi-eye
                      </v-icon>

                      <v-btn
                        medium
                        outlined
                        class="mr-4 hidden-md-and-up"
                        color="light-blue darken-4"
                        @click="viewItem(item)"
                      >
                        view
                      </v-btn>

                      <v-icon
                        v-if="i != 1 && !isAuditorRole"
                        small
                        class="hidden-sm-and-down"
                        @click="onDeleteItem(item)"
                      >
                        mdi-delete
                      </v-icon>

                      <v-btn
                        v-if="i != 1 && !isAuditorRole"
                        medium
                        outlined
                        class="hidden-md-and-up red--text"
                        @click="onDeleteItem(item)"
                      >
                        delete
                      </v-btn>
                    </template>
                    <template v-slot:no-data>
                      <v-btn
                        color="#2b3990"
                        class="white--text"
                        @click="getMedHandOffs()"
                        >Reset</v-btn
                      >
                    </template>
                  </v-data-table>
                </v-card>
              </template>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>

    <OptionMenu :onAction="handleActions" :showActions="showActions" />
  </div>
</template>

<script>
/*eslint-disable */
import ClientNav from "@/components/ClientNav";
import ClientSide from "@/components/ClientSide";
import ActionControlMenu from "@/components/ActionControlMenu";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  props: {},
  components: {
    ClientNav,
    ClientSide,
    ActionControlMenu,
  },
  data: function () {
    return {
      headers: [
        {
          text: "Start Date",
          align: "start",
          sortable: false,
          value: "startDate",
        },
        { text: "End Date", value: "endDate" },
        { text: "Person Receiving Meds", value: "receiving" },
        { text: "Relationship to Client", value: "relation" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      titleForm: "New Med Hand Off",
      editMedHandOff: false,
      clientID: this.$route.params.clientID,
      userID: localStorage.getItem("userID"),
      selectedTab: null,
      tab: null,
      search: "",
      items: ["Outgoing", "Incoming"],
      medHandOffData: null,
      medications: [],
      medicationListItem: [],
      incoming: false,
      showActions: {
        add: true,
        print: true,
        download: true,
      },
      payload: {},
    };
  },

  computed: {
    ...mapGetters({
      allClientMedHandOffData: "medhandoff/allClientMedHandOffData",
      getMedications: "medhandoff/getMedications",
      client: "clients/clientData",
    }),

    userRole() {
      return this.$store.state.users.user.Role === "Administration";
    },

    isAuditorRole() {
      return localStorage.getItem("userRole") === 'Auditor'
    },

    navigateTo() {
      return {
        path: `/medHandOff/${this.clientID}/add`,
      };
    },
  },

  created() {
    this.fetch();
  },

  mounted(){
    this.showActions.add = !this.isAuditorRole;
  },

  watch: {
    isAuditorRole(newVal) {
      this.showActions.add = !newVal; 
    }
  },

  methods: {
    ...mapActions("medhandoff", [
      "fetchItems",
      "fetchMedicationItem",
      "deleteItem",
    ]),

    ...mapMutations({
      setDialog: "medhandoff/SET_DIALOG",
      setSnackbar: "SET_SNACKBAR",
    }),

    initializePayload() {
      this.payload = {
        query: {
          name: this.client?.Name,
          clientId: this.client?._id,
          generateFile: true,
          page: this.currentPage,
          limit: this.itemsPerPage,
          keyword: this.searchKeyword,
          searchFields: this.headers
            .filter((h) => h.value !== "actions")
            .map((h) => h.value),
        },
        endpoints: `medHandOff/client/${this.client?._id}`,
        dynamic: true,
        fileName: `${this.client?.Name}-medication-handoff.pdf`,
      };
    },

    async fetch() {
      await this.fetchItems(this.clientID);
      this.initializePayload()
    },

    async showDialog() {
      this.$router.push({
        path: `/medHandOff/${this.clientID}/add`,
      });
    },

    async viewItem(item) {
      this.$router.push({
        path: `/medHandOff/${this.clientID}/edit`,
        query: {
          id: item._id,
          new: false,
          incoming: this.tab === 1 ? true : false,
        },
      });
    },

    async onDeleteItem(item) {
      let confirmDeletion = confirm(
        "Are you sure you want to delete this MedHandOff?"
      );
      if (confirmDeletion) {
        try {
          const response = await this.deleteItem(item._id);
          if (response.data.success) {
            this.setSnackbar({
              show: true,
              text: "The med hand off form has been deleted successfully",
              color: "green accent-4",
            });
            this.fetch();
          }
        } catch (error) {
          console.log(error);
        }
      }
    },

    onChangeTab(item) {
      this.incoming = item === 0 ? false : true;
    },

    handleActions(action) {
      if (this.$refs.actions) {
        this.$refs.actions[0].onSelectAction(action);
      } else {
        console.error("reference not found");
      }
    },
  },
};
</script>
<style>
@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}
</style>
